var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.className},[_c('div',{ref:"canvas-dag",staticClass:"butterfly-vue-container"},[_c('div',{staticClass:"butterfly-progress"},[_vm._v(_vm._s(_vm.percentage)+"%")])])])}
var staticRenderFns = []

export { render, staticRenderFns }